import React, { useEffect, useState } from 'react';
import Grid from "@material-ui/core/Grid";
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Paper from "@material-ui/core/Paper";
import { withRouter } from "react-router-dom";
import SentenceForm from "./SentenceForm";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import clsx from "clsx";
import RentHouseAddress from "../survey/RentHouseAddress";
import FormHelperText from "@material-ui/core/FormHelperText";
import { useRecoilState } from "recoil";
import { answerState, rentState } from "../../state/globalState";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import RemoveIcon from "@material-ui/icons/Remove";
import { numberToKorean } from '../../utils/numberTokorean'
import { formatWithComma } from '../../utils/utils'


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    formControlLabel: {
        fontFamily: 'Noto Sans KR',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '15px'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        borderRadius: 15,
        backgroundColor: "#1b6817",
        padding: '5px 30px',
        height: 35,
        fontSize: "15px",
        color: 'white',
        '&:hover': {
            backgroundColor: '#767676',
            color: '#ffffff'
        }
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#1b6817',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    addButton: {
        margin: '10px 0',
        backgroundColor: '#1b6817',
        color: 'white',
        '&:hover': {
            backgroundColor: '#767676',
        }
    },
    periodContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '10px',
        margin: '10px 0',
        flexWrap: 'wrap'
    },
    dateInput: {
        width: '150px'
    },
    datePickerDialog: {
        '& .MuiDialog-paper': {
            padding: '20px'
        }
    },
    date: {
        width: "160px",
        padding: "8px",
        margin: "10px 0"
    },
    buttonContainer: {
        display: 'flex',
        gap: '10px',
        margin: '10px 0'
    },
    deleteButton: {
        margin: '10px 0',
        backgroundColor: '#d32f2f',
        color: 'white',
        '&:hover': {
            backgroundColor: '#767676',
        },
        '&:disabled': {
            backgroundColor: '#cccccc',
            color: '#666666'
        }
    },
    dateFieldBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
    },
    dateRangeRow: {
        display: 'flex',
        alignItems: 'flex-end',
        gap: '10px'
    },
    dateRangeSep: {
        paddingBottom: '14px',
        lineHeight: 1
    },
    depositFieldBox: {
        // 데스크탑/기본: 날짜 입력들과 같은 줄
    },
    dateLabel: {
        marginBottom: '4px',
        fontSize: '13px'
    },
    labelRow: {
        display: 'flex',
        alignItems: 'baseline',
        gap: '8px',
        width: '100%'
    },
    amountReadingLabel: {
        fontSize: '12px',
        color: '#666',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        flex: 1,
        minWidth: 0
    },
    amountRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    amountReading: {
        fontSize: '12px',
        color: '#666',
        whiteSpace: 'nowrap'
    },
    [theme.breakpoints.down('sm')]: {
        depositFieldBox: {
            flexBasis: '100%',
            marginTop: '6px'
        }
    }
}));

const HouseAccordion = ({ houseNo, id, setProcess, history }) => {
    const [answer, setAnswer] = useRecoilState(answerState);
    const [rent, setRent] = useRecoilState(rentState);
    const [isRent, setIsRent] = useState(false);
    const house = rent.house[id];
    const { validateMode } = answer;
    const classes = useStyles();
    const [rentPeriods, setRentPeriods] = useState([{ startDate: '', endDate: '', rentDepositAmt: '' }]);
    const [expanded, setExpanded] = useState(true);

    useEffect(() => {
        if (rent.house[id]?.rentPeriods) {
            setRentPeriods(rent.house[id].rentPeriods);
        }
    }, [rent.house[id]]);

    // useEffect(() => {
    //     console.log("MODE >>> ", validateMode);
    //     console.log("taxAccntYn >>> ", house.taxAccntYn);
    //     if (validateMode && house.taxAccntYn === "1") {
    //         if (house.taxAccntNm === "" || house.taxAccntTelno === "") {
    //             dispatch(setValidateResult(false));
    //         }
    //     } else if (validateMode && house.taxAccntYn === "0") {
    //         if (house.rentAgentNm === "" || house.rentIncomeAmt === "" || house.rentDepositAmt === ""
    //             || house.jointYn === "" || (house.jointYn === "1" && house.shareRate === "") || house.stdMktAmt === "" || house.ddcArea === ""
    //             || house.rentAgentNm === "" || house.rentAgentZpcd === "" || house.rentAgentAddrDetls === "") {
    //             dispatch(setValidateResult(false));
    //         }
    //     }
    // }, [validateMode]);

    const handleCheckBoxChange = (val) => {
        if (val) {
            const newHouseCheckList = {
                ...rent,
                houseChecklist: [
                    ...rent.houseChecklist,
                    id
                ]
            }
            setRent(newHouseCheckList);
        } else {
            const newHouseCheckList = {
                ...rent,
                houseChecklist: rent.houseChecklist.filter(item => item !== id)
            }
            setRent(newHouseCheckList);
        }
        setIsRent(val);
    };

    const handleInputAnswer = (e, column) => {
        const { value, name } = e.target;

        if ("rentIncomeAmt" === column || "rentDepositAmt" === column || "stdMktAmt" === column) {
            const regexp = /\B(?=(\d{3})+(?!\d))/g;
            const onlyNums = value.replace(/[^0-9]/g, '');
            const toNum = Number(onlyNums);

            if (toNum.toString().length <= 12) {
                const replacedValue = toNum.toString().replace(regexp, ',');

                const tmpObj = rent.house[id];
                const newHouseData = {
                    ...tmpObj,
                    [column]: replacedValue
                };

                const newRentData = {
                    ...rent,
                    house: {
                        ...rent.house,
                        [id]: newHouseData
                    }
                }
                setRent(newRentData);
            }
        } else if ("ddcArea" === column) {
            const onlyNums = value.replace(/[^0-9.-]/g, '');
            const toNum = Number(onlyNums);

            if (toNum.toString().length <= 8) {
                const parts = onlyNums.split('.');
                const integerPart = parts[0] ? parts[0].replace(/\B(?=(\d{3})+$)/g, ',') : '';
                const decimalPart = parts[1] !== undefined ? '.' + parts[1].slice(0, 2) : '';
                const resultValue = integerPart + decimalPart;

                const tmpObj = rent.house[id];
                const newHouseData = {
                    ...tmpObj,
                    [column]: resultValue
                };

                const newRentData = {
                    ...rent,
                    house: {
                        ...rent.house,
                        [id]: newHouseData
                    }
                }
                setRent(newRentData);
            }
        } else if ("shareRate" === column) {
            if (value.length <= 50) {
                const tmpObj = rent.house[id];
                const newHouseData = {
                    ...tmpObj,
                    [column]: value
                };

                const newRentData = {
                    ...rent,
                    house: {
                        ...rent.house,
                        [id]: newHouseData
                    }
                }
                setRent(newRentData);
            }
        } else if ("taxAccntNm" === column) {
            if (value.length <= 30) {
                const tmpObj = rent.house[id];
                const newHouseData = {
                    ...tmpObj,
                    [column]: value
                };

                const newRentData = {
                    ...rent,
                    house: {
                        ...rent.house,
                        [id]: newHouseData
                    }
                }
                setRent(newRentData);
            }
        } else if ("taxAccntTelno" === column) {
            const onlyNums = value.replace(/[^0-9]/g, '');

            if (onlyNums.length <= 20) {
                const tmpObj = rent.house[id];
                const newHouseData = {
                    ...tmpObj,
                    [column]: onlyNums
                };

                const newRentData = {
                    ...rent,
                    house: {
                        ...rent.house,
                        [id]: newHouseData
                    }
                }
                setRent(newRentData);
            }
        } else if ("taxAccntMail" === column) {
          const tmpObj = rent.house[id];
          const newHouseData = {
            ...tmpObj,
            [column]: value
          };

          const newRentData = {
            ...rent,
            house: {
              ...rent.house,
              [id]: newHouseData
            }
          }
          setRent(newRentData);
        } else if ("rentAgentNm" === column) {
            if (value.length <= 50) {
                const tmpObj = rent.house[id];
                const newHouseData = {
                    ...tmpObj,
                    [column]: value
                };

                const newRentData = {
                    ...rent,
                    house: {
                        ...rent.house,
                        [id]: newHouseData
                    }
                }
                setRent(newRentData);
            }
        } else if ("rentAgentZpcd" === column) {
            if (value.length <= 6) {
                const tmpObj = rent.house[id];
                const newHouseData = {
                    ...tmpObj,
                    [column]: value
                };

                const newRentData = {
                    ...rent,
                    house: {
                        ...rent.house,
                        [id]: newHouseData
                    }
                }
                setRent(newRentData);
            }
        } else if ("rentAgentAddrDetls" === column) {
            if (value.length <= 60) {
                const tmpObj = rent.house[id];
                const newHouseData = {
                    ...tmpObj,
                    [column]: value
                };

                const newRentData = {
                    ...rent,
                    house: {
                        ...rent.house,
                        [id]: newHouseData
                    }
                }
                setRent(newRentData);
            }
        } else if ("jointYn" === column) {
            if (value === "0") {
                const tmpObj = rent.house[id];
                const newHouseData = {
                    ...tmpObj,
                    [column]: value,
                    shareRate: ""
                };

                const newRentData = {
                    ...rent,
                    house: {
                        ...rent.house,
                        [id]: newHouseData
                    }
                }
                setRent(newRentData);
            } else {
                const tmpObj = rent.house[id];
                const newHouseData = {
                    ...tmpObj,
                    [column]: value
                };

                const newRentData = {
                    ...rent,
                    house: {
                        ...rent.house,
                        [id]: newHouseData
                    }
                }
                setRent(newRentData);
            }

        } else if ("taxAccntYn" === column) {
            const tmpObj = rent.house[id];

            if (value === "1") {
                const newHouseData = {
                    ...tmpObj,
                    taxAccntYn: value,
                    rentAgentNm: "",
                    rentIncomeAmt: "",
                    rentDepositAmt: "",
                    jointYn: "",
                    shareRate: "",
                    stdMktAmt: "",
                    ddcArea: "",
                    bizRegYn: "",
                    rentBizYn: "",
                    rentAgentZpcd: "",
                    rentAgentAddr: "",
                    rentAgentAddrDetls: "",
                    houseRentYn: "1"
                };

                const newRentData = {
                    ...rent,
                    house: {
                        ...rent.house,
                        [id]: newHouseData
                    }
                }
                setRent(newRentData);
            } else {
                const newHouseData = {
                    ...tmpObj,
                    taxAccntYn: value,
                    taxAccntNm: "",
                    taxAccntTelno: "",
                    taxAccntMail: "",
                    houseRentYn: "1"
                };

                const newRentData = {
                    ...rent,
                    house: {
                        ...rent.house,
                        [id]: newHouseData
                    }
                }
                setRent(newRentData);
            }

        } else {
            const tmpObj = rent.house[id];
            const newHouseData = {
                ...tmpObj,
                [column]: value
            };

            const newRentData = {
                ...rent,
                house: {
                    ...rent.house,
                    [id]: newHouseData
                }
            }
            setRent(newRentData);
        }
    };

    const StyledRadio = (props) => {
        return (
            <Radio
                disableRipple
                color="default"
                checked={house["taxAccntYn"] === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'taxAccntYn')}
                {...props}
            />
        );
    };

    const RentRadio = (props) => {
        return (
            <Radio
                disableRipple
                color="default"
                checked={house["houseRentYn"] === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'houseRentYn')}
                {...props}
            />
        );
    };

    const JointRadio = (props) => {
        return (
            <Radio
                disableRipple
                color="default"
                checked={house["jointYn"] === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'jointYn')}
                {...props}
            />
        );
    };

    const BizRegRadio = (props) => {
        return (
            <Radio
                disableRipple
                color="default"
                checked={house["bizRegYn"] === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'bizRegYn')}
                {...props}
            />
        );
    };

    const RentBizRadio = (props) => {
        return (
            <Radio
                disableRipple
                color="default"
                checked={house["rentBizYn"] === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'rentBizYn')}
                {...props}
            />
        );
    };

    const handleAddPeriod = () => {
        setRentPeriods([...rentPeriods, { startDate: '', endDate: '' }]);
    };

    const handlePeriodChange = (index, field, value) => {
      let nextValue = value;

      if (field === "rentDepositAmt") {
        const onlyNums = String(value).replace(/[^0-9]/g, "");

        // 빈값 허용
        if (!onlyNums) {
          nextValue = "";
        } else if (onlyNums.length <= 12) {
          // state에는 숫자만 저장
          nextValue = onlyNums;
        } else {
          // 12자리 초과면 기존값 유지
          nextValue = rentPeriods[index]?.rentDepositAmt ?? "";
        }
      }

        const newPeriod = {
            ...rentPeriods[index],
            [field]: nextValue
        };

        const newPeriods = rentPeriods.map((period, i) =>
            i === index ? newPeriod : period
        );

        setRentPeriods(newPeriods);

        const tmpObj = rent.house[id];
        const newHouseData = {
            ...tmpObj,
            rentPeriods: newPeriods
        };

        const newRentData = {
            ...rent,
            house: {
                ...rent.house,
                [id]: newHouseData
            }
        }
        setRent(newRentData);
    };

    const handleDeletePeriod = (e) => {
        e.stopPropagation();
        if (rentPeriods.length > 1) {
            const newPeriods = rentPeriods.slice(0, -1);
            setRentPeriods(newPeriods);

            const tmpObj = rent.house[id];
            const newHouseData = {
                ...tmpObj,
                rentPeriods: newPeriods
            };

            const newRentData = {
                ...rent,
                house: {
                    ...rent.house,
                    [id]: newHouseData
                }
            }
            setRent(newRentData);
        }
    };

    const handleAccordionChange = (event) => {
        event.stopPropagation();
        setExpanded(!expanded);
    };

    return (
        <React.Fragment>
            <Grid container
                direction="column"
                alignItems="flex-start"
                justifyContent="center"
            >
                <div className={classes.root}>
                    <Accordion
                        expanded={expanded}
                        onChange={handleAccordionChange}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-label="Expand"
                            aria-controls="additional-actions1-content"
                            id="additional-actions1-header"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <FormControlLabel
                                aria-label="Acknowledge"
                                onClick={(event) => event.stopPropagation()}
                                onFocus={(event) => event.stopPropagation()}
                                control={<Checkbox name="house-rent-checkbox" checked={isRent} onChange={(e) => handleCheckBoxChange(e.target.checked)} />}
                                label={<Typography className={classes.formControlLabel}>{`[임대 주택${houseNo}] 상세정보`}</Typography>}
                            />
                        </AccordionSummary>
                        <AccordionDetails onClick={(e) => e.stopPropagation()}>
                            <Paper style={{ overflow: 'hidden', padding: '20px', width: "100%" }}>
                                <SentenceForm
                                    title="해당 '주택'을 임대 중입니까? "
                                    sentences={[]}
                                    step="25-0"
                                />
                                <FormControl component="fieldset" style={{ margin: '10px 20px 0 25px' }} error={validateMode && house.taxAccntYn === ""}>
                                    <RadioGroup defaultValue="0" aria-label="" name="" row>
                                        <FormControlLabel key="25-0-Y" value="1"
                                            control={<RentRadio />} label="예" />
                                        <FormControlLabel key="25-0-N" value="0"
                                            control={<RentRadio />} label="아니오" />
                                    </RadioGroup>
                                    {(validateMode && house.houseRentYn === "") && <FormHelperText>필수 입력항목입니다.</FormHelperText>}
                                </FormControl>
                                {/* 위 답변이 '예'*/}
                                {house.houseRentYn === "1" && (
                                    <>
                                        <SentenceForm
                                            title="해당 '주택'을 개인세무사를 통해 임대소득 및 비용에 관한 장부 작성 및 신고를 진행하고 계십니까? "
                                            sentences={[]}
                                            step="25-1"
                                        />
                                        <FormControl component="fieldset" style={{ margin: '10px 20px 0 25px' }} error={validateMode && house.taxAccntYn === ""}>
                                            <RadioGroup defaultValue="0" aria-label="" name="" row>
                                                <FormControlLabel key="22-1-Y" value="1"
                                                    control={<StyledRadio />} label="예" />
                                                <FormControlLabel key="22-1-N" value="0"
                                                    control={<StyledRadio />} label="아니오" />
                                            </RadioGroup>
                                            {(validateMode && house.houseRentYn === "1" && house.taxAccntYn === "") && <FormHelperText>필수 입력항목입니다.</FormHelperText>}
                                        </FormControl>
                                    </>
                                )}

                                {/* 위 답변이 '예'*/}
                                {(house.houseRentYn === "1" && house.taxAccntYn === "1") && (
                                    <div>
                                        <SentenceForm
                                            title="개인세무사의 성함 및 연락처를 기재 부탁드립니다.<br />(EY에서 개인세무사님에게 직접 연락하여 임대소득 내용 요청하겠습니다)"
                                            sentences={[]}
                                            step="25-1-1"
                                        />
                                        <div className="textFieldContainer">
                                            <TextField
                                                label="성함"
                                                placeholder=""
                                                margin="none"
                                                onChange={(e) => handleInputAnswer(e, 'taxAccntNm')}
                                                value={house.taxAccntNm}
                                                error={validateMode && house.taxAccntNm === ''}
                                                helperText={(validateMode && house.taxAccntNm === '') && '필수 입력 항목입니다.'}
                                            />
                                        </div>
                                        <div className="textFieldContainer">
                                            <TextField
                                                label="전화번호"
                                                placeholder=""
                                                margin="none"
                                                onChange={(e) => handleInputAnswer(e, 'taxAccntTelno')}
                                                value={house.taxAccntTelno}
                                                error={validateMode && house.taxAccntTelno === ''}
                                                helperText={(validateMode && house.taxAccntTelno === '') && '필수 입력 항목입니다.'}
                                            />
                                        </div>
                                        <div className="textFieldContainer">
                                            <TextField
                                                label="이메일주소"
                                                type="email"
                                                placeholder=""
                                                margin="none"
                                                onChange={(e) => handleInputAnswer(e, 'taxAccntMail')}
                                                value={house.taxAccntMail}
                                                error={validateMode && house.taxAccntMail === ''}
                                                helperText={(validateMode && house.taxAccntMail === '') && '필수 입력 항목입니다.'}
                                            />
                                        </div>
                                    </div>
                                )}

                                {/* 위 답변이 '아니오'*/}
                                {(house.houseRentYn === '1' && house.taxAccntYn === '0') && (
                                    <div>
                                        <SentenceForm
                                            title="임대 부동산(사업명) - 사업명이 없는 경우 성함을 기재해주시기 바랍니다."
                                            sentences={[]}
                                            step="25-1-1"
                                        />
                                        <div className="textFieldContainer">
                                            <TextField
                                                label="여기에 답변을 입력하십시오."
                                                placeholder=""
                                                margin="none"
                                                onChange={(e) => handleInputAnswer(e, 'rentAgentNm')}
                                                value={house.rentAgentNm}
                                                error={validateMode && house.rentAgentNm === ""}
                                                helperText={(validateMode && house.rentAgentNm === "") && "필수 입력 항목입니다."}
                                            />
                                        </div>

                                        <RentHouseAddress id={id} />
                                        <SentenceForm
                                            title="임대 기간 (보증금이 연중 변경된 경우 변경 전후 기간을 나누어 입력)"
                                            sentences={[]}
                                            step="25-1-1"
                                        />
                                        <div style={{ margin: '0 25px' }} onClick={(e) => e.stopPropagation()}>
                                            {rentPeriods.map((period, index) => (
                                                <div
                                                    key={index}
                                                    className={classes.periodContainer}
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <div className={classes.dateRangeRow} onClick={(e) => e.stopPropagation()}>
                                                        <div className={classes.dateFieldBox} onClick={(e) => e.stopPropagation()}>
                                                            <label className={classes.dateLabel}>시작일</label>
                                                            <input
                                                                className={classes.date}
                                                                type="date"
                                                                max="9999-12-31"
                                                                value={period.startDate}
                                                                onChange={(e) => {
                                                                    e.stopPropagation();
                                                                    handlePeriodChange(index, 'startDate', e.target.value);
                                                                }}
                                                                onClick={(e) => e.stopPropagation()}
                                                            />
                                                        </div>
                                                        <span className={classes.dateRangeSep}>~</span>
                                                        <div className={classes.dateFieldBox} onClick={(e) => e.stopPropagation()}>
                                                            <label className={classes.dateLabel}>종료일</label>
                                                            <input
                                                                className={classes.date}
                                                                type="date"
                                                                max="9999-12-31"
                                                                value={period.endDate}
                                                                onChange={(e) => {
                                                                    e.stopPropagation();
                                                                    handlePeriodChange(index, 'endDate', e.target.value);
                                                                }}
                                                                onClick={(e) => e.stopPropagation()}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className={`${classes.dateFieldBox} ${classes.depositFieldBox}`} onClick={(e) => e.stopPropagation()}>
                                                        <div className={classes.labelRow}>
                                                            <label className={classes.dateLabel}>임대보증금</label>
                                                            {period.rentDepositAmt && (
                                                                <span
                                                                    className={classes.amountReadingLabel}
                                                                    title={numberToKorean(period.rentDepositAmt)}
                                                                >
                                                                    {numberToKorean(period.rentDepositAmt)}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className={classes.amountRow}>
                                                            <TextField
                                                                className={classes.date}
                                                                placeholder=""
                                                                margin="none"
                                                                onChange={(e) => handlePeriodChange(index, 'rentDepositAmt', e.target.value)}
                                                                value={formatWithComma(period.rentDepositAmt)}
                                                                error={validateMode && period.rentDepositAmt === ""}
                                                                helperText={(validateMode && period.rentDepositAmt === "") && "필수 입력 항목입니다."}
                                                                inputProps={{
                                                                  style: { textAlign: "right" },
                                                                  inputMode: "numeric",
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            <div className={classes.buttonContainer}>
                                                <Button
                                                    variant="contained"
                                                    className={classes.addButton}
                                                    startIcon={<AddIcon />}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleAddPeriod();
                                                    }}
                                                >
                                                    기간 추가
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    className={classes.deleteButton}
                                                    disabled={rentPeriods.length <= 1}
                                                    startIcon={<RemoveIcon />}
                                                    onClick={handleDeletePeriod}
                                                >
                                                    기간 삭제
                                                </Button>
                                            </div>
                                        </div>
                                        <SentenceForm
                                            title="연간 총 임대수입(월세) 금액(단위:원)"
                                            sentences={['계약서 상 총 임대수입금액(= 월세액 x 임대월수)을 입력해주십시오. 임차인과의 협의에 따라 월세액을 인하한 경우 해당 월세액을 사용하여 계산된 금액을 입력해주십시오.</br>분배비율과 관계없이 총 수입금액을 기재부탁드립니다.</br>전세금만 있는 경우, \'0\'으로 기재해주시고 임대보증금에 전세금을 기입해주시기 바랍니다.']}
                                            step="25-1-1"
                                        />
                                        <div className="textFieldContainer">
                                            <div className={classes.amountRow}>
                                                <TextField
                                                    label="여기에 답변을 입력하십시오."
                                                    placeholder=""
                                                    margin="none"
                                                    onChange={(e) => handleInputAnswer(e, 'rentIncomeAmt')}
                                                    value={formatWithComma(String(house.rentIncomeAmt).replace(/,/g, ''))}
                                                    error={validateMode && house.rentIncomeAmt === ""}
                                                    helperText={(validateMode && house.rentIncomeAmt === "") && "필수 입력 항목입니다."}
                                                    inputProps={{
                                                        style: { textAlign: 'right' },
                                                        inputMode: 'numeric'
                                                    }}
                                                />
                                                {house.rentIncomeAmt && (
                                                    <span
                                                        className={classes.amountReading}
                                                        style={{ alignSelf: 'center' }}
                                                        title={numberToKorean(String(house.rentIncomeAmt).replace(/,/g, ''))}
                                                    >
                                                        {numberToKorean(String(house.rentIncomeAmt).replace(/,/g, ''))}
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        {/*<SentenceForm*/}
                                        {/*    title="임대보증금 (단위 : 원)"*/}
                                        {/*    sentences={[]}*/}
                                        {/*    step="25-1-1"*/}
                                        {/*/>*/}
                                        {/*<div className="textFieldContainer">*/}
                                        {/*    <TextField*/}
                                        {/*        label="여기에 답변을 입력하십시오."*/}
                                        {/*        placeholder=""*/}
                                        {/*        margin="none"*/}
                                        {/*        onChange={(e) => handleInputAnswer(e, 'rentDepositAmt')}*/}
                                        {/*        value={house.rentDepositAmt}*/}
                                        {/*        error={validateMode && house.rentDepositAmt === ""}*/}
                                        {/*        helperText={(validateMode && house.rentDepositAmt === "") && "필수 입력 항목입니다."}*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                        <SentenceForm
                                            title="공동소유여부"
                                            sentences={[]}
                                            step="25-1-1"
                                        />
                                        <FormControl component="fieldset" style={{ margin: '10px 20px 0 25px' }} error={validateMode && house.jointYn === ""}>
                                            <RadioGroup defaultValue="0" aria-label="" name="" row>
                                                <FormControlLabel key="25-1-Y" value="1"
                                                    control={<JointRadio />} label="예" />
                                                <FormControlLabel key="25-1-N" value="0"
                                                    control={<JointRadio />} label="아니오" />
                                            </RadioGroup>
                                            {(validateMode && house.jointYn === "") && <FormHelperText>필수 입력항목입니다.</FormHelperText>}
                                        </FormControl>

                                        {/* 공동소유여부 '예' 일경우 */}
                                        {house.jointYn === "1" && (
                                            <div>
                                                <SentenceForm
                                                    title="지분비율 혹은 지정된 손익분배비율(예: 본인 60 : 배우자 40)"
                                                    sentences={[]}
                                                    step="25-1-1"
                                                />
                                                <div className="textFieldContainer">
                                                    <TextField
                                                        label="여기에 답변을 입력하십시오."
                                                        placeholder=""
                                                        margin="none"
                                                        onChange={(e) => handleInputAnswer(e, 'shareRate')}
                                                        value={house.shareRate}
                                                        error={validateMode && house.jointYn === "1" && house.shareRate === ""}
                                                        helperText={(validateMode && house.jointYn === "1" && house.shareRate === "") && "필수 입력 항목입니다."}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        <SentenceForm
                                            title="2025년 12월 31일 (양도하였을 경우 양도일 기준) 기준시가"
                                            sentences={[]}
                                            step="25-1-1"
                                        />
                                        <div className="textFieldContainer">
                                            <div className={classes.amountRow}>
                                                <TextField
                                                    label="여기에 답변을 입력하십시오."
                                                    placeholder=""
                                                    margin="none"
                                                    onChange={(e) => handleInputAnswer(e, 'stdMktAmt')}
                                                    value={formatWithComma(String(house.stdMktAmt).replace(/,/g, ''))}
                                                    error={validateMode && house.stdMktAmt === ""}
                                                    helperText={(validateMode && house.stdMktAmt === "") && "필수 입력 항목입니다."}
                                                    inputProps={{
                                                        style: { textAlign: 'right' },
                                                        inputMode: 'numeric'
                                                    }}
                                                />
                                                {house.stdMktAmt && (
                                                    <span
                                                        className={classes.amountReading}
                                                        style={{ alignSelf: 'center' }}
                                                        title={numberToKorean(String(house.stdMktAmt).replace(/,/g, ''))}
                                                    >
                                                        {numberToKorean(String(house.stdMktAmt).replace(/,/g, ''))}
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        <SentenceForm
                                            title="주거전용면적 (단위: m²)"
                                            sentences={[]}
                                            step="25-1-1"
                                        />
                                        <div className="textFieldContainer">
                                            <TextField
                                                label="소수점 2자리까지 입력 가능"
                                                placeholder=""
                                                margin="none"
                                                onChange={(e) => handleInputAnswer(e, 'ddcArea')}
                                                value={house.ddcArea}
                                                error={validateMode && house.ddcArea === ""}
                                                helperText={(validateMode && house.ddcArea === "") && "필수 입력 항목입니다."}
                                            />
                                        </div>

                                        <SentenceForm
                                            title="해당 주택은 세무서에서 개인사업자로 사업자등록증에 등록이 된 임대주택입니까?"
                                            sentences={["'예' 인 경우, 사업자등록증 사본을 질문지 하단 <a href='/survey#27' style='color: #26A9E3; padding-left: 6px; font-weight: bold'>질문3-7</a>에 업로드 해주시기 바랍니다."]}
                                            step="25-1-1"
                                        />
                                        <FormControl component="fieldset" style={{ margin: '10px 20px 0 25px' }} error={validateMode && house.bizRegYn === ""}>
                                            <RadioGroup defaultValue="0" aria-label="" name="" row>
                                                <FormControlLabel key="25-1-Y" value="1"
                                                    control={<BizRegRadio />} label="예" />
                                                <FormControlLabel key="25-1-N" value="0"
                                                    control={<BizRegRadio />} label="아니오" />
                                            </RadioGroup>
                                            {(validateMode && house.bizRegYn === "") && <FormHelperText>필수 입력항목입니다.</FormHelperText>}
                                        </FormControl>

                                        {/* 임대주택 '예' 인경우 */}
                                        {/*<div>*/}
                                        {/*    <div className="blockquote-box">*/}
                                        {/*        <div>*/}
                                        {/*            사업자등록증 사본을 업로드해주시기 바랍니다.*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*    <br/>*/}
                                        {/*    <div style={{marginLeft: '25px'}}>*/}
                                        {/*        <FileDropZone key={"fileDropZone"} step={29} setProcess={setProcess}/>*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}

                                        <SentenceForm
                                            title="해당 주택은 관할 시군구청에서 임대사업자등록증에 등록이 된 임대주택입니까?"
                                            sentences={["'예' 인 경우, 임대사업자등록증사본, 표준임대차계약서사본, 임대차계약신고이력확인서 및 임대조건신고증서 사본을 <a href='/survey#27' style='color: #26A9E3; padding-left: 6px; font-weight: bold'>질문3-7</a>에 업로드해주시기 바랍니다."]}
                                            step="25-1-1"
                                        />
                                        <FormControl component="fieldset" style={{ margin: '10px 20px 0 25px' }} error={validateMode && house.rentBizYn === ""}>
                                            <RadioGroup defaultValue="0" aria-label="" name="" row>
                                                <FormControlLabel key="25-1-Y" value="1"
                                                    control={<RentBizRadio />} label="예" />
                                                <FormControlLabel key="25-1-N" value="0"
                                                    control={<RentBizRadio />} label="아니오" />
                                            </RadioGroup>
                                            {(validateMode && house.rentBizYn === "") && <FormHelperText>필수 입력항목입니다.</FormHelperText>}
                                        </FormControl>

                                        {/* 임대주택 '예' 인경우 */}
                                        {/*<div>*/}
                                        {/*    <div className="blockquote-box">*/}
                                        {/*        <div>*/}
                                        {/*            임대사업자등록증사본, 표준임대차계약서사본, 임대차계약신고이력확인서 및 임대조건신고증서 사본을*/}
                                        {/*        </div>*/}
                                        {/*        <div>*/}
                                        {/*            업로드해주시기 바랍니다.*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*    <br/>*/}
                                        {/*    <div style={{marginLeft: '25px'}}>*/}
                                        {/*        <FileDropZone key={"fileDropZone"} step={29} setProcess={setProcess}/>*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                    </div>
                                )}

                            </Paper>
                        </AccordionDetails>
                    </Accordion>
                </div>
            </Grid>
        </React.Fragment>
    );
};

export default withRouter(HouseAccordion);
